<div class="checkin__booking__price" [ngClass]="{ 'checkin__booking__price--full' : full }" >
  <span class="checkin__booking__price__total">{{ 'total-booking' | translate }}</span>
  <span>{{ amount | formatCurrency:currency }}</span>
</div>
<div class="checkin__booking__currency-info" *ngIf="mcp.enabled">
  <span>{{ translations.currencyInfoTitle.slug | translate }}</span>
  <span [innerHTML]="translations.currencyInfoDescription.slug | translate:translations.currencyInfoDescription.params | safeHtml" ></span>
</div>
